import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { compose } from 'recompose'
import { connect } from 'react-redux'
import { get } from 'lodash'
import { renderRoutes } from 'react-router-config'
import { myOrganization } from 'constants/layout'
import { meta } from 'helpers/decorators'
import { apiCodeLists, apiConfiguration } from 'helpers/decorators/api'
import { CONFIGURATION_KEYS, ORGANIZATION_HIERARCHY } from 'constants/enums'

const enhance = compose(
  meta({
    title: 'My Organization',
    intlKey: 'pageTitle.my_organization'
  }),
  apiCodeLists(['organizationTypes'], {
    public: true
  }),
  apiConfiguration({
      getValues: [
        CONFIGURATION_KEYS.enableOrganizationLabels.id
      ]
  }),
  connect(({ auth }) => ({
    activeOrganization: auth.organization
  }))
)

class MyOrganization extends Component {
  static propTypes = {
    children: PropTypes.any.isRequired,
    activeOrganization: PropTypes.object.isRequired,
    codeLists: PropTypes.object.isRequired,
    tabs: PropTypes.object,
    route: PropTypes.object,
    configuration: PropTypes.object.isRequired,

  }

  render() {
    const { children, tabs, codeLists, activeOrganization, route, configuration } = this.props

    const isIac = get(activeOrganization, 'hierarchyLevelType.value') === ORGANIZATION_HIERARCHY.IAC.value

    const isParticipantLabelsEnabled = get(configuration, `valuesByOrganizationId[${activeOrganization.id}][${CONFIGURATION_KEYS.enableLabels.id}].booleanValue`)

    const isAwardLabelsEnabled = get(configuration, `valuesByOrganizationId[${activeOrganization.id}][${CONFIGURATION_KEYS.enableAwardLabels.id}].booleanValue`)

    const isLabelsEnabled = isParticipantLabelsEnabled || isAwardLabelsEnabled

    const extraProps = { codeLists }

    return (
      <div>
        {tabs &&
          React.cloneElement(tabs, {
            links: myOrganization.tabs({ isIac, isLabelsEnabled }),
            prefix: myOrganization.root
          })}
        {children
          ? React.cloneElement(children, extraProps)
          : renderRoutes(route.routes, extraProps)
        }
      </div>
    )
  }
}

export default enhance(MyOrganization)
